export enum UtcDateTimeOptions {
  UtcDateWithTime,
  UtcDateWithoutTime,
  UtcDateWithoutTimeZone,
}
